import React from "react";
import YieldSummaryTable from "./components/YieldSummaryTable";
import MonthlyDistributionChart from "./components/MonthlyDistributionChart";
import PortfolioConfigData from "config/portfolio-config.json";
import commonStyles from "pages/assistant/components/artifacts/components/fineco-portfolio/finecoPortfolio.common.module.scss";
import YieldSummaryTableCompare from "./components/YieldSummaryTableCompare";
import MonthlyDistributionChartCompare from "./components/MonthlyDistributionChartCompare";

type SectionChildrenProps = {
  reportData: any;
  reportData2?: any;
};

const DistribuzioneDeiProventiContainer: React.FC<SectionChildrenProps> = ({
  reportData,
  reportData2,
}) => {
  if (!reportData) {
    return null;
  }

  const configData = PortfolioConfigData.caratteristiche_di_portafoglio.data;

  return (
    <>
      {!reportData2 && (
        <div
          className={
            commonStyles.sectionContainerDistribuzioneDeiProventiContainer
          }
        >
          <div className={commonStyles.distribuzioneProventiContainer}>
            <div className={commonStyles.distribuzioneProventiContainerInner}>
              <div
                className={
                  commonStyles.distribuzioneProventiContainerInnerInner
                }
              >
                <YieldSummaryTable
                  dataObject={
                    reportData.caratteristiche_di_portafoglio.yield_summary
                  }
                />
              </div>
              <div>
                <MonthlyDistributionChart
                  label={configData.distribuzione_mensile_proventi.label}
                  data={
                    reportData.caratteristiche_di_portafoglio
                      .distribuzione_mensile_proventi
                  }
                />
              </div>
            </div>
          </div>
        </div>
      )}
      {reportData2 && (
        <div
          className={
            commonStyles.sectionContainerDistribuzioneDeiProventiContainer
          }
        >
          <div className={commonStyles.distribuzioneProventiContainer}>
            <div
              className={
                commonStyles.distribuzioneProventiContainerCompareInner
              }
            >
              <div
                className={
                  commonStyles.distribuzioneProventiContainerInnerInner
                }
              >
                <YieldSummaryTableCompare
                  dataObject={
                    reportData.caratteristiche_di_portafoglio.yield_summary
                  }
                  dataObject2={
                    reportData2.caratteristiche_di_portafoglio.yield_summary
                  }
                />
              </div>
              <div>
                <MonthlyDistributionChartCompare
                  label={configData.distribuzione_mensile_proventi.label}
                  data={
                    reportData.caratteristiche_di_portafoglio
                      .distribuzione_mensile_proventi
                  }
                  data2={
                    reportData2.caratteristiche_di_portafoglio
                      .distribuzione_mensile_proventi
                  }
                />
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default React.memo(
  DistribuzioneDeiProventiContainer,
  (prevProps: SectionChildrenProps, nextProps: SectionChildrenProps) => {
    return prevProps.reportData === nextProps.reportData;
  },
);
